// extracted by mini-css-extract-plugin
export default {"marginTop":"CommonInputField_marginTop__Sij84","marginBottom":"CommonInputField_marginBottom__V-ipu","lableStyle":"CommonInputField_lableStyle__Ca-N4"};